<template>
  <div>
    <b-modal
      ref="add-hw-model-modal"
      id="add-hw-model-modal"
      title="เพิ่ม Model"
      size="sm"
      hide-footer
    >
      <b-card-text>
        <label>Model</label>
        <b-form-input id="smallInput" size="sm" placeholder="715A" class="mb-1" v-model="modelData.hwModelName"/>

        <label>สถานะ</label>
        <b-form-group>
          <b-form-radio-group
            v-model="modelData.hwModelStatus"
            :options="statusOptions"            
            name="radio-inline"
          />
        </b-form-group>

        <!--- START (BTN SUBMIT) --->
        <b-row class="mt-2">
          <b-col md="12" class="d-flex justify-content-end">
            <b-button variant="primary"  @click="save"
              >บันทึก</b-button
            >
          </b-col>
        </b-row>
        <!--- END (BTN SUBMIT) --->
      </b-card-text>
    </b-modal>
  </div>
</template>

<script>
import {
  VBModal,
  BCardText,
  BRow,
  BCol,
  BFormInput,  
  BFormRadioGroup,
  BFormGroup,
  BButton 
} from "bootstrap-vue";

export default {
  props:['modelData'],
  components: {
    BCardText,
    BRow,
    BCol,
    BFormInput,    
    BFormRadioGroup,
    BFormGroup,
    BButton
  },
  directives: {
    "b-modal": VBModal,
  },
  data() {
    return {
      statusOptions: [
        { text: 'เปิด', value: 1 },
        { text: 'ปิด', value: 0 },        
      ],
  
    };
  },
  methods: {
    save() {
      if(!this.modelData.hwModelName){
        alert("กรุณากรอกชื่อรุ่น")
        return
      }

      this.$emit("emitSaveHwModel")
      this.$refs["add-hw-model-modal"].hide();
    },
  },
};
</script>

<style>
@import "./style.css";
</style>
